import { BlockComponentFactory } from '../BlockFactory'
import { ContainerBlockProps } from './block-props.types'
import { useBlockChildren } from '../../hooks/useBlockChildren'
import { ContainerBlock } from './ContainerBlock'

export type ContainerBlockRuntimeProps = ContainerBlockProps & {
    childBlockConfigIds?: string[]
}

export const ContainerBlockRuntimeComponent =
    BlockComponentFactory.createBlockComponent<ContainerBlockRuntimeProps>(props => {
        const { childBlockConfigIds, ...restProps } = props

        const children = useBlockChildren(childBlockConfigIds)

        return <ContainerBlock {...restProps} children={children} />
    })
